import { render, staticRenderFns } from "./footer_logos.vue?vue&type=template&id=7837f03c&scoped=true&"
import script from "./footer_logos.vue?vue&type=script&lang=js&"
export * from "./footer_logos.vue?vue&type=script&lang=js&"
import style0 from "./footer_logos.vue?vue&type=style&index=0&id=7837f03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7837f03c",
  null
  
)

export default component.exports